export default __webpack_public_path__ + "static/media/hackathon-level-1.ae1e5711.svg";